import "./chunk--chunk-RQ7252KT.js";

// src/js/components/SmoothScroll.js
var SmoothScroll = class {
  constructor(el) {
    this.el = el;
    this.nav = el.querySelector("[data-smooth-scroll-nav]");
    this.anchors = el.querySelectorAll("[data-smooth-scroll-anchor]");
    this.currentAnchor = null;
    this.previousAnchor = null;
    this.initCurrentEl();
    this.initEventListeners();
    this.initScrollObservers();
    this.scrollDirection = "down";
  }
  initCurrentEl() {
    let currentEl = window.location.href.split("#")[1];
    if (currentEl) {
      currentEl = currentEl.split("?")[0];
      currentEl = currentEl.split("&")[0];
      const connectedEl = this.el.querySelector(`[data-slide-observer="#${currentEl}"]`);
      currentEl = this.el.querySelector(`a[href="#${currentEl}"]`);
      if (!currentEl)
        return;
      currentEl.classList.add("active");
      this.currentAnchor = currentEl;
      this.scrollToEl(connectedEl);
    }
  }
  initEventListeners() {
    const stickyListener = () => {
      const headerHeight = document.querySelector("header").getBoundingClientRect().height;
      this.nav.style.top = `${headerHeight}px`;
    };
    window.addEventListener("resize", stickyListener);
    stickyListener();
    this.anchors.forEach((anchor) => {
      anchor.addEventListener("click", (e) => {
        e.preventDefault();
        const anchorHref = anchor.getAttribute("href");
        window.history.replaceState(null, "", anchorHref);
        const currentEl = this.nav.querySelector(".active");
        if (currentEl) {
          currentEl.classList.remove("active");
        }
        anchor.classList.add("active");
        const connectedEl = this.el.querySelector(`[data-slide-observer="${anchorHref}"]`);
        this.scrollToEl(connectedEl);
      });
    });
  }
  initScrollObservers() {
    window.addEventListener("scroll", () => {
      if (window.prevScrollDirection > window.scrollY) {
        this.scrollDirection = "up";
      } else {
        this.scrollDirection = "down";
      }
      window.prevScrollDirection = window.scrollY;
    });
    this.anchors.forEach((anchor, i) => {
      window.addEventListener("scroll", () => {
        const observeRect = this.el.querySelector(
          `[data-slide-observer="${anchor.getAttribute("href")}"]`
        ).getBoundingClientRect();
        if (this.scrollDirection === "down") {
          if (observeRect.top < 300) {
            anchor.classList.add("active");
            if (this.anchors[i - 1])
              [this.anchors[i - 1].classList.remove("active")];
          }
        }
        if (this.scrollDirection === "up") {
          if (observeRect.top > 700 && anchor.classList.contains("active")) {
            anchor.classList.remove("active");
            this.anchors[i - 1].classList.add("active");
          }
        }
        const activeEl = this.el.querySelector(".active");
        if (window.scrollY < 150 && activeEl) {
          activeEl.classList.remove("active");
        }
      });
    });
  }
  scrollToEl(connectedEl) {
    const navOffset = this.nav.getBoundingClientRect().height + 150;
    const destination = connectedEl.getBoundingClientRect().top + window.scrollY - navOffset;
    window.scrollTo({
      top: destination,
      behavior: "smooth"
    });
  }
};
var SmoothScroll_default = SmoothScroll;
export {
  SmoothScroll_default as default
};
